module.exports = __webpack_public_path__ + "static/media/annotated-river-map-expanded.fa86624c.svg";